import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MultiSelectOptionsPipe } from './multi-select/multi-select-options.pipe';
import { MultiSelectComponent } from './multi-select/multi-select.component';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule],
  declarations: [MultiSelectComponent, MultiSelectOptionsPipe],
  exports: [MultiSelectComponent, ReactiveFormsModule]
})
export class SharedFormsModule {}
